import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

interface OutbidEmailData {
  recipientEmail: string;
  recipientName: string;
  starName: string;
  bookingDate: string;
  bookingTime: string;
  originalBid: number;
  newBid: number;
  slotDuration: number;
}

interface BookingConfirmationData {
  recipientEmail: string;
  recipientName: string;
  starName: string;
  bookingDate: string;
  bookingTime: string;
  duration: number;
  price: number;
  roomUrl?: string;
}

/**
 * Send outbid notification email to the previous booking holder
 */
export const sendOutbidEmail = async (data: OutbidEmailData): Promise<void> => {
  try {
    const response = await axios.post(
      `${API_URL}/api/email/send-outbid-notification`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    
    console.log('Outbid email sent:', response.data);
  } catch (error) {
    console.error('Failed to send outbid email:', error);
    // Don't throw error - email failure shouldn't break the booking process
  }
};

/**
 * Send booking confirmation email
 */
export const sendBookingConfirmationEmail = async (
  data: BookingConfirmationData
): Promise<void> => {
  try {
    const response = await axios.post(
      `${API_URL}/api/email/send-booking-confirmation`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    
    console.log('Booking confirmation email sent:', response.data);
  } catch (error) {
    console.error('Failed to send booking confirmation email:', error);
    // Don't throw error - email failure shouldn't break the booking process
  }
};

/**
 * Send call ready notification email (1 hour before call)
 */
export const sendCallReadyEmail = async (
  recipientEmail: string,
  recipientName: string,
  starName: string,
  callTime: string,
  roomUrl: string
): Promise<void> => {
  try {
    const response = await axios.post(
      `${API_URL}/email/send-call-ready`,
      {
        recipientEmail,
        recipientName,
        starName,
        callTime,
        roomUrl,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    
    console.log('Call ready email sent:', response.data);
  } catch (error) {
    console.error('Failed to send call ready email:', error);
    // Don't throw error - email failure shouldn't break the booking process
  }
};


